import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { PostmethodService } from '../../app-config/postmethod.service';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  GET_DD_REPORT, GET_ENQUIRY_REPORT, DOWNLOAD_REPORT
} from '../graphql/report';

@Injectable({
  providedIn: 'root'
})
export class ReportsService {

  constructor(private ws: PostmethodService, private apollo: Apollo) { }

  getReportsList() {
    return this.ws.wsGet(environment.loginUrl + "/reports/ho-reports-list");
  }
  generateReport() {
    return this.ws.wsGet(environment.loginUrl + "/reports/checkReportsByUser");
  }
  downloadReports(item: any) {
    return this.ws.wsGet(environment.loginUrl + "/reports/downloadReportByUserId/" + item.id);
  }
  downloadReport(filters: any): Observable<any> {
    return this.apollo
      .query({
        query: DOWNLOAD_REPORT,
        variables: { filters },
        fetchPolicy: 'network-only',
      })
      .pipe(
        map((result: any) => {
          const data = result.data;
          return data;
        })
      );
  }
  getDDReportData(filters: any): Observable<any> {
    return this.apollo
      .query({
        query: GET_DD_REPORT,
        variables: { filters },
        fetchPolicy: 'network-only',
      })
      .pipe(
        map((result: any) => {
          const data = result.data;
          return data;
        })
      );
  }
  getEnquiryReportData(filters: any): Observable<any> {
    return this.apollo
      .query({
        query: GET_ENQUIRY_REPORT,
        variables: { filters },
        fetchPolicy: 'network-only',
      })
      .pipe(
        map((result: any) => {
          const data = result.data;
          return data;
        })
      );
  }
}
